export const USER_EMAIL_VERIFICATION_NOT_REQUIRED = 0;
export const USER_EMAIL_VERIFICATION_REQUIRED = 1;
export const USER_EMAIL_VERIFICATION_COMPLETED = 2;
